export const MEASURES = ['QUERY COUNT', 'QUERY TIME', 'CLOUD SERVICES CREDITS', 'COMPUTE CREDITS'];
export const SECONDARY_DIMENSIONS = ['', 'WAREHOUSE', 'USER'];

export enum DashboardTabs {
    SPEND_OVERVIEW = 'spendOverview',
    WAREHOUSE_USAGE = 'warehouseUsage'
}

export enum PrimaryDimensions {
    DATE = 'DATE',
    WAREHOUSE = 'WAREHOUSE',
    USER = 'USER'
}

export enum ChartType {
    LINE_CHART = 'LineChart',
    BAR_CHART = 'BarChart'
}

export enum DateBin {
    AUTO = 'AUTO',
    HOUR = 'HOUR',
    WEEKDAY = 'WEEKDAY',
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    QUARTER = 'QUARTER',
    YEAR = 'YEAR'
}

export enum TrendDirection {
    UP = 'UP',
    NEUTRAL = 'NEUTRAL',
    DOWN = 'DOWN',
    NOT_APPLICABLE = 'NOT_APPLICABLE'
}

export const TrendIcon = {
    [TrendDirection.UP]: 'nav-up',
    [TrendDirection.NEUTRAL]: 'nav-forward',
    [TrendDirection.DOWN]: 'nav-down',
    [TrendDirection.NOT_APPLICABLE]: 'dash-dash'
};

export const CARDINALITY_THRESHOLD = 50;

export enum ROI_CHART_KEY {
    AVG_QUERY_COUNT = 'AVG_QUERY_COUNT',
    AVG_QUERY_TIME = 'AVG_QUERY_TIME',
    AVG_RUNTIME = 'AVG_RUNTIME',
    AVG_RECORDS_WRITTEN = 'AVG_RECORDS_WRITTEN'
}

export const ASSET_ROI_MEASURES = ['QUERY_COUNT', 'QUERY_TIME', 'RECORDS_WRITTEN'];
export enum AssetRoiDimensions {
    DATE = 'DATE',
    ACCESS_TYPE = 'ACCESS_TYPE',
    TABLE = 'TABLE',
    USER = 'USER',
    WAREHOUSE = 'WAREHOUSE'
}

export const ACCESS_TYPE = ['READ', 'WRITE'];

export enum ROIReportTabs {
    ROI_OVERVIEW = 'ROIOverview',
    ASSET_ROI = 'assetROI'
}
